import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const listDistrict = async (payload) => {
    const { data } = await apiInstance.post(ENDPOINTS.DISTRICT_LIST, payload);
    return data
}
